import * as React from "react";
import Header from "./Header";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { connect } from "react-redux";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import {
    ApplicationAction,
    setChildrenCount,
    setChildAge,
    gotoStep
} from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { StringUtil } from "../../util/stringUtil";
import {
    Button,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Row,
    Col
} from "reactstrap";
import { trackEvent } from "../../util/gtm";
import { RootState } from "../../store";
import { Child } from "../../lib-api";

const SliderWithTooltip = createSliderWithTooltip(Slider);

type Props = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

interface State {
    children: Array<Child>;
}

class Children extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            children: props.children
        }
    }

    clickedChild(val): void {
        const children = [];
        for (var i = 0; i < val; i++) {
            children.push({ age: 9 });
        }
        if (children.length == 0) {
            this.next();
        }
        else {
            this.setState({
                children: children
            });
        }

        //this.setState({ show: true })
        //this.props.setChildrenCount(val)
    }
    next(): void {
        this.props.setChildrenCount(this.state.children)
        trackEvent(
            "Hjemmeboende børn",
            "Børn: " + this.state.children.length,
            "Hjemmeboende børn",
            this.state.children.length
        )
    }

    resetChild(): void {
        this.setState({
            children: []
        });
       
    }
    private choices: Array<Choice<number>> = [
        new Choice<number>("0", 0, () =>  this.next()),
        new Choice<number>("1", 1, val => this.clickedChild(val)),
        new Choice<number>("2", 2, val => this.clickedChild(val)),
        new Choice<number>("3", 3, val => this.clickedChild(val)),
        new Choice<number>("4", 4, val => this.clickedChild(val)),
        new Choice<number>("5", 5, val => this.clickedChild(val)),
        new Choice<number>("6+", 6, val => this.clickedChild(val))
    ];
    amountFormatter(value: number): string {
        return StringUtil.numberWithCommas(value) + " år.";
    }
    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "7");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)

        return (
            <div>
                <Header formStep={FormStep.Other} step={Step.Children}  />
                <ApplicationContent>
                    <div className="row"><div className="text-center col"><h3 className="text-uppercase">Hjemmeboende børn?</h3></div></div>
                    <div className="row"><div className="text-center col"><p>Hvis du har hjemmeboende børn under 18 år skal det angives her</p></div></div>
                    {this.state.children.length == 0 && <MultipleChoiceForm
                        title=""
                        paragraph=""
                        choices={this.choices}
                    />}
                    
                    {this.state.children.length > 0 &&
                        this.state.children.map((child, index) => (<div className="childSliders" key={index}>
                            <div className="row"><div className="text-center col"><h4 className="text-uppercase">Barn {index + 1}</h4></div></div>
                        
                            <SliderWithTooltip
                                tipFormatter={this.amountFormatter}
                                tipProps={{ defaultVisible: true, visible: true }}
                                onChange={(val) => {
                                    const newChildren = this.state.children;
                                    newChildren[index].age = val
                                    this.setState({
                                        children: newChildren
                                    });

                                    //console.log(this.state)
                                }}
                                step={1}
                                min={0}
                                max={18}
                                defaultValue={child.age}
                            />
                            <div className="d-flex justify-content-between slider mb-5">
                                <div className="label">0 år.</div>
                                <div className="label">18 år</div>
                            </div>
                        </div>))
                    }
                    

                </ApplicationContent>
                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                            {this.state.children.length > 0 &&
                                <Button className="back" onClick={() => this.resetChild()}>
                                    Tilbage
                            </Button>
                            }

                            {this.state.children.length == 0 &&
                                <Button className="back" onClick={() => this.props.previous()}>
                                    Tilbage
                            </Button>
                            }
                           
                            {this.state.children.length > 0 &&
                                <Button className="next" onClick={() => {
                                    this.next();

                                }}>
                                    Næste
                        </Button>
                            }
                           
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    previous: () => dispatch(gotoStep(Step.Marital)),
    //next: () => dispatch(gotoStep(Step.Coappliant)),
    //setChildAge: (amount: number) => dispatch(setChildAge(amount)),
    setChildrenCount: (children: Array<Child>) => {
        dispatch(setChildrenCount(children));
   
    
    }

});
const mapStateToProps = (state: RootState) => ({
    children: state.applicationState.data.children
});
export default connect(mapStateToProps, mapDispatchToProps)(Children);
